module.exports = __webpack_public_path__ + "static/media/productos_otros_jamaica.38e002cb.jpg";